import React from 'react';
import { required } from 'redux-form-validators';
import { Field, FormSection } from 'redux-form';
import GroupType from './components/GroupType';
import Insured from './components/Insured/Insured';

const YourDetailsTab = ({ groupType, productCode, rules }) => {
  return (
    <div className={'pa-tab-content'}>
      <FormSection name={'data.attributes.metadata'}>
        <Field
          name={'group_type'}
          component={GroupType}
          validate={required({ msg: 'Group Type is Required' })}
        />
        <Insured groupType={groupType} productCode={productCode} rules={rules} />
      </FormSection>
    </div>
  );
};

export default YourDetailsTab;
